
  export default {
    mounted() {
      // this.$store.dispatch('auth/loadAuthData') // Загрузка данных из localStorage
    },
  }
